module.exports = __webpack_public_path__ + "media/images/pool-8c94a97a08ff44a2364dc891dec3519d.svg";